export default {
  path: ":alias/settings",
  component: resolve => require(["@/views/settings"], resolve),
  children: [
    {
      path: "form",
      component: resolve => require(["@/views/settings/form"], resolve)
    }
  ]
};
